import ctl from "@netlify/classnames-template-literals";

export const container = ctl(`
   flex 
   flex-col 
   justify-between 
   items-center
   mt-3
   w-full 
   gap-6
`);

export const formContainer = ctl(`
   flex 
   flex-col 
   gap-y-6 
   items-start
   w-full
`);

export const topContainer = ctl(`
   pt-20
   pb-36
   flex
   flex-col
   gap-y-8
   mx-auto
   w-full
   max-w-3xl
`);

export const bottomContainer = ctl(`
   flex
   flex-col
   gap-y-16
   mx-auto
   w-full
   max-w-3xl
`);

// Loader styles
export const loader = {
  backgroundHeader: ctl(`
    relative
    h-[200px]
    w-full
    bg-neutral-100
  `),

  gradientOverlay: ctl(`
    absolute
    inset-0
    bg-gradient-to-r
    from-neutral-200
    to-neutral-100
    animate-pulse
  `),

  headerContent: ctl(`
    absolute
    inset-0
    flex
    items-center
    justify-center  
    max-w-3xl
  `),
};

export const submitButton = ctl(`
  bg-neutral-300
  rounded-full
  absolute
  bottom-3
  right-3
  p-1.5
  flex
  items-center
  justify-center
  transition-all
  duration-200
`);

export const submitButtonDisabled = ctl(`
  opacity-50
  cursor-not-allowed
`);
